import { render, staticRenderFns } from "./Bienparabien.vue?vue&type=template&id=b794232a&"
import script from "./Bienparabien.vue?vue&type=script&lang=js&"
export * from "./Bienparabien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBanner,QBtn,QIcon,QToolbar,QToolbarTitle,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBanner,QBtn,QIcon,QToolbar,QToolbarTitle,QTable,QTd})
